import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>Página Não Encontrada</h2>
            <p>Desculpe, a página que você está procurando não existe.</p>
        </div>
    );
};

export default NotFound;